import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core/dist/esm/es6/rendering/cellRenderers/iCellRenderer';

@Component({
    selector: 'app-boolean-cell-renderer',
    templateUrl: './boolean-cell-renderer.component.html',
    styleUrls: ['./boolean-cell-renderer.component.scss'],
    standalone: false,
})
export class BooleanCellRendererComponent implements ICellRendererAngularComp {
    @Input() set displayValue(value: string) {
        this._displayValue = value === '(Select All)' ? value : value.toString();
    }

    get displayValue(): string {
        return this._displayValue;
    }

    @Input() isFloatingFilterIcon?: boolean = false;

    private _displayValue: string = '';

    agInit(params: ICellRendererParams & { isFloatingFilterIcon?: boolean }): void {
        this.isFloatingFilterIcon = Boolean(params.isFloatingFilterIcon);
        this.displayValue = params.value;
    }

    refresh(): boolean {
        return false;
    }
}
